"use client";

import { useRouter } from "next/navigation";
import {
  ProfileMagicProgressCard,
  ProfileMagicProgressCardSkeleton,
} from "@/app/components/profile-magic/ProfileMagicProgressCard";
import { useProfileMagicWorkspace } from "@/hooks/useProfileMagicWorkspace";

type Props = {
  workspaceId: string;
};

export function ProfileMagicServiceBanner({ workspaceId }: Props) {
  const router = useRouter();
  const pm = useProfileMagicWorkspace(workspaceId);

  if (pm.loading) {
    return <ProfileMagicProgressCardSkeleton />;
  }

  if (!pm.readiness || pm.readiness.percent >= 100) {
    return null;
  }

  return (
    <ProfileMagicProgressCard
      readiness={pm.readiness}
      onContinue={() =>
        router.push(
          `/profile-magic?workspaceId=${encodeURIComponent(workspaceId)}`,
        )
      }
    />
  );
}
